// globals: jQuery

import cardConnectIframeAbstract from './cardConnectFrameAbstract';

var CardConnectTakePayment;

(function($) {

    CardConnectTakePayment = new cardConnectIframeAbstract({
        formSelector: '#cardConnectFrameFormDialog',
        frameContainer: 'dialogForm_cardConnectFrame',
        cardConnectParamsToFormSelector: '.credit-card-form',
        iframeLocation: 'pos',
        cssRules: [
            'input{height:17px;padding:2px;float:right;width:155px;font-size:12px;font-weight:bold;border-width:1px;}',
            'label{display:inline-block;float:left;font-size:12px;font-weight:bold;font-family:Tahoma,Arial;width:126px;text-align:right;padding-right:20px;margin-top:11px;}',
            'select{width:70px;height:21px;margin-right:10px;}',
            'br{display:none}',
            '.error{color:red;}',
            '@media (max-width: 320px) {label{display:flex;margin-bottom:12px;}}',
        ],
        frameOptions : {
            useexpiry : 'true',
            usecvv : 'true',
            cardlabel : 'Card Number:',
            expirylabel : 'Expiration:',
            cvvlabel : 'CVV:',
            orientation : 'custom',
            placeholdercvv: 'Code',
            placeholdermonth: 'Month',
            placeholderyear: 'Year',
            unique: false,
            formatinput : true,
            autofocus : true,
            invalidinputevent : true,
            enhancedresponse: true
        }
    });

})(jQuery);

export default CardConnectTakePayment;
